import Constant from '@/common/constant/Constant';
import { useState, useEffect } from 'react';
import StatusFieldUI from '../../../formManagement/fieldUI/StatusFieldUI';

export default function OriginStatusField({
    detailTicket,
    selectedAssigneeUserId,
    isDisableEdit,
    API,
    setShowButtonEditTicket,
    setNewStatusOfTicket,
    newStatusData,
    setNewStatusData,
    listFieldEdited,
    setOnChangeEdit,
    name,
    setListFieldEdited,
    statusDetail,
    isHelpDesk,
    setStatusNo,
    currentPanelInitData,
    currentItemData,
    fieldListDefaultData,
    setIsEdited,
}) {
    const [thisField, setThisField] = useState({});

    /**find status field and fill its data. */
    useEffect(() => {
        let fieldWorkFlow = fieldListDefaultData.find(
            field => field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
        );

        if (fieldWorkFlow) {
            setThisField(fieldWorkFlow);
        }
    }, [fieldListDefaultData]);

    return (
        <StatusFieldUI
            detailTicket={detailTicket}
            selectedAssigneeUserId={selectedAssigneeUserId}
            isDisableEdit={isDisableEdit}
            fieldData={thisField}
            API={API}
            setShowButtonEditTicket={setShowButtonEditTicket}
            setNewStatusOfTicket={setNewStatusOfTicket}
            setNewStatusData={setNewStatusData}
            listFieldEdited={listFieldEdited}
            setOnChangeEdit={setOnChangeEdit}
            name={thisField?.id}
            setListFieldEdited={setListFieldEdited}
            statusDetail={statusDetail}
            isHelpDesk={isHelpDesk}
            setStatusNo={setStatusNo}
            currentPanelInitData={currentPanelInitData}
            currentItemData={currentItemData}
            newStatusData={newStatusData}
            setIsEdited ={setIsEdited}
        />
    );
}
